module.exports = __webpack_public_path__ + "img/848c6536ad66d67cee81883ae64d1e4d.png";